import React from 'react';
import HandCarryIphoneAppImageSource from './images/merchants-iphone-app.png';
import HandCarryAppLogoSource from './images/merchants-app-logo.png';
import { DownloadHandCarryApp } from './DownloadHandCarryApp';
import { STYLES } from '../../../../style';

const DownloadMerchantsApp = () => <DownloadHandCarryApp iphoneImage={HandCarryIphoneAppImageSource} appImage={HandCarryAppLogoSource} bgColor={STYLES.COLOR_CORN_FLOWER_BLUE} />;

export { DownloadMerchantsApp };